import i18n from '@/lang';
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import AMap from 'AMap';
/**
 * @param urlData  base64
 * @param fileName 文件名称
 * @returns {File}
 */
export function base64ToFile(urlData, fileName) {
  var arr = urlData.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bytes = atob(arr[1]); // 解码base64
  var n = bytes.length;
  var ia = new Uint8Array(n);
  while (n--) {
    ia[n] = bytes.charCodeAt(n);
  }
  return new File([ia], fileName, {
    type: mime
  });
}

/* 任意数据拷贝 */
export var deepCopy = function deepCopy(data) {
  var target; // 不能使用let 因为无法先声明在赋值
  if (!(data instanceof Object)) {
    // 返回基本类型
    return data;
  } else if (data instanceof Array) {
    target = [];
  } else if (data instanceof Object) {
    target = {};
  } else if (data instanceof Function) {
    // target = eval(data)
  }
  for (var key in data) {
    target[key] = deepCopy(data[key]);
  }
  return target;
};

// 2018-1-1 00:00 转换为 Wed Jul 25 2018 14:11:22 GMT+0800 (中国标准时间)
var formatDate = function formatDate(data) {
  var time = data.split(' ');
  var sdate = time[0].split('-');
  var date = '';
  if (sdate.length > 0) {
    date = new Date(sdate[0], sdate[1] - 1, sdate[2]);
  } else {
    date = new Date();
  }
  if (time[1]) {
    var _date;
    var stime = time[1].split(':');
    (_date = date).setHours.apply(_date, _toConsumableArray(stime));
  }
  return date;
};
var date = {
  // 一天的时间戳
  oneDay: 24 * 60 * 60 * 1000,
  // 2018-1-1 00:00 转换为 Wed Jul 25 2018 14:11:22 GMT+0800 (中国标准时间)
  formatDate: function formatDate(data) {
    var time = data.split(' ');
    var sdate = time[0].split('-');
    var date = new Date(sdate[0], sdate[1] - 1, sdate[2]);
    if (time[1]) {
      var stime = time[1].split(':');
      date.setHours.apply(date, _toConsumableArray(stime));
    }
    return date;
  },
  // 获取当前时刻起间隔count天日期 count：3未来三天、-3过去三天
  getIntervalDayStartAndEnd: function getIntervalDayStartAndEnd() {
    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var nowDate = new Date();
    var start = nowDate.Format(format);
    var end = new Date(nowDate.setTime(nowDate.getTime() + this.oneDay * count)).Format(format);
    startStop.push(start);
    startStop.push(end);
    return count >= 0 ? startStop : startStop.reverse();
  },
  // 获取今天日期 monthCount：0今天、-1昨天、1明天
  getDayStartAndEnd: function getDayStartAndEnd() {
    var dayCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var start = new Date(new Date().setHours(0, 0, 0) + this.oneDay * dayCount).Format(format);
    var end = new Date(new Date().setHours(23, 59, 59) + this.oneDay * dayCount).Format(format);
    startStop.push(start);
    startStop.push(end);
    return dayCount >= 0 ? startStop : startStop.reverse();
  },
  // 获取本月日期 monthCount：0当前月、-1上一个月、1下一个月
  getMonthStartAndEnd: function getMonthStartAndEnd() {
    var monthCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var currentDate = new Date();
    var month = currentDate.getMonth() + monthCount;
    if (month < 0) {
      var n = parseInt(-month / 12);
      month += n * 12;
      currentDate.setFullYear(currentDate.getFullYear() - n);
    }
    currentDate = new Date(currentDate.setMonth(month));
    // 获得当前月份 0-11
    var currentMonth = currentDate.getMonth();
    // 获得当前年份4位年
    var currentYear = currentDate.getFullYear();
    // 获得上一个月的第一天
    var currentMonthFirstDay = new Date(currentYear, currentMonth, 1).Format(format);
    // 获得上一月的最后一天
    var currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0).setHours(23, 59, 59);
    currentMonthLastDay = new Date(currentMonthLastDay).Format(format);
    startStop.push(currentMonthFirstDay);
    startStop.push(currentMonthLastDay);
    return startStop;
  },
  // 获取本月日期 weekCount：0当本周、-1上一周、1下一周
  getWeekStartAndEnd: function getWeekStartAndEnd() {
    var weekCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
    var startStop = [];
    var now = new Date();
    var nowTime = now.getTime();
    var day = now.getDay(); // 本周的第几天
    var MondayTime = nowTime - (day - 1) * this.oneDay + weekCount * 7 * this.oneDay;
    var SundayTime = nowTime + (7 - day) * this.oneDay + weekCount * 7 * this.oneDay;
    var start = new Date(MondayTime).setHours(0, 0, 0);
    var end = new Date(SundayTime).setHours(23, 59, 59);
    start = new Date(start).Format(format);
    end = new Date(end).Format(format);
    startStop.push(start);
    startStop.push(end);
    return weekCount >= 0 ? startStop : startStop.reverse();
  }
};

/* eslint-disable */
var rotateBase64Img = function rotateBase64Img(src, edg, callback) {
  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');
  var imgW; //图片宽度
  var imgH; //图片高度
  var size; //canvas初始大小

  if (edg % 90 != 0) {
    console.error('旋转角度必须是90的倍数!');
    throw '旋转角度必须是90的倍数!';
  }
  edg < 0 && (edg = edg % 360 + 360);
  var quadrant = edg / 90 % 4; //旋转象限
  var cutCoor = {
    sx: 0,
    sy: 0,
    ex: 0,
    ey: 0
  }; //裁剪坐标

  var image = new Image();
  image.crossOrigin = 'anonymous';
  image.src = src;
  image.onload = function () {
    imgW = image.width;
    imgH = image.height;
    size = imgW > imgH ? imgW : imgH;
    canvas.width = size * 2;
    canvas.height = size * 2;
    switch (quadrant) {
      case 0:
        cutCoor.sx = size;
        cutCoor.sy = size;
        cutCoor.ex = size + imgW;
        cutCoor.ey = size + imgH;
        break;
      case 1:
        cutCoor.sx = size - imgH;
        cutCoor.sy = size;
        cutCoor.ex = size;
        cutCoor.ey = size + imgW;
        break;
      case 2:
        cutCoor.sx = size - imgW;
        cutCoor.sy = size - imgH;
        cutCoor.ex = size;
        cutCoor.ey = size;
        break;
      case 3:
        cutCoor.sx = size;
        cutCoor.sy = size - imgW;
        cutCoor.ex = size + imgH;
        cutCoor.ey = size + imgW;
        break;
    }
    ctx.translate(size, size);
    ctx.rotate(edg * Math.PI / 180);
    ctx.drawImage(image, 0, 0);
    var imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
    if (quadrant % 2 == 0) {
      canvas.width = imgW;
      canvas.height = imgH;
    } else {
      canvas.width = imgH;
      canvas.height = imgW;
    }
    ctx.putImageData(imgData, 0, 0);
    callback(canvas.toDataURL());
  };
};
var getLocation = function getLocation() {
  return new Promise(function (resolve, reject) {
    AMap.plugin('AMap.Geolocation', function () {
      var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
        convert: true,
        showButton: true,
        buttonPosition: 'LB',
        buttonOffset: new AMap.Pixel(10, 20),
        showMarker: true,
        showCircle: true,
        panToLocation: true,
        zoomToAccuracy: true
      });
      geolocation.getCurrentPosition();
      AMap.event.addListener(geolocation, 'complete', function (data) {
        if (data.info === 'SUCCESS') {
          resolve({
            coor: [data.position.lng, data.position.lat],
            address: data.formattedAddress || ''
          });
        } else {
          resolve({
            coor: [],
            address: ''
          });
        }
      });
      AMap.event.addListener(geolocation, 'error', function (e) {
        resolve({
          coor: [],
          address: ''
        });
      });
    });
  });
};
var getLngLat = function getLngLat() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return new Promise(function (resolve, reject) {
    AMap.plugin('AMap.Geocoder', function () {
      var geocoder = new AMap.Geocoder();
      geocoder.getLocation(address, function (status, result) {
        if (status === 'complete' && result.info === 'OK' && result.geocodes.length) {
          resolve([result.geocodes[0].location.lng, result.geocodes[0].location.lat]);
        } else {
          reject();
        }
      });
    });
  });
};
export function funcUrlDel(name) {
  var search = new URLSearchParams(location.search);
  search.delete(name);
  return search;
}
export default {
  deepCopy: deepCopy,
  formatDate: formatDate,
  date: date,
  rotateBase64Img: rotateBase64Img,
  getLocation: getLocation,
  getLngLat: getLngLat
};